export { NileInlineSidebarItemHeader } from './nile-inline-sidebar-item-header';